import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomInputGroupModule } from "../custom-input-group/custom-input-group.module";
import { FormInputErrorModule } from "../form-input-error/form-input-error.module";
import { ListItemModule } from "../list-item/list-item.module";
import { PhoneInputModule } from "../phone-input/phone-input.module";
import { PipesModule } from "../pipes/pipes.module";
import { ModeOfServiceComponent } from "./mode-of-service.component";
import { PersonAvatarModule } from "../person-avatar/person-avatar.module";

@NgModule({
  declarations: [ModeOfServiceComponent],
  imports: [
    CommonModule,
    PipesModule,
    ListItemModule,
    FormsModule,
    ReactiveFormsModule,
    FormInputErrorModule,
    CustomInputGroupModule,
    PhoneInputModule,
    PersonAvatarModule
  ],
  exports: [ModeOfServiceComponent],
})
export class ModeOfServiceModule {}
